
import {Tier} from "@/utils/tier";
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components";
import AppCompanyFiltersModules from "./CompanyFiltersModules.vue";
import AppCompanyEmploteyeeSelect from "./CompanyEmployeeSelect.vue";
import { CompanyFilters } from "@/utils/company-filters";
import AppSelectDiscoveredUsFrom from "@/components/company/SelectDiscoveredUsFrom.vue";
import AppSelectCompanyDidNotPurchaseReason from "@/components/company/SelectCompanyDidNotPurchaseReason.vue";
import AppCompanyFiltersVars from "@/components/company/CompanyFiltersVars.vue";
import { MetricService } from "@/services/metric-service";
import { DbInfo } from "@/models/db-info";

export default Vue.extend({
	data() {
		return {
			v: new CompanyFilters(),
			availableDbs: [] as DbInfo[]
		};
	},
	props: {
		value: {
			type: Object as () => CompanyFilters
		}
	},
	computed: {
		dbItems():ISelectItem<number | null>[]{
			let result:ISelectItem<number | null>[] = [
				{
					text: "Geen",
					value: null,
				}
			];
			result.push(...this.availableDbs.map(a=>{
				return {
					text: a.toString(),
					value: a.id
				} as ISelectItem<number | null>;
			}));
			return result;
		},
		starter(): Tier {
			return Tier.Starter;
		},
		free(): Tier {
			return Tier.Free;
		},
		pro(): Tier {
			return Tier.Pro;
		},
		proplus(): Tier {
			return Tier.ProfessionalPlus;
		},
		enterprise(): Tier {
			return Tier.Enterprise;
		},
		employeeItems(): ISelectItem<boolean | null>[] {
			return [
				{
					text: "Both",
					value: null
				},
				{
					text: "Clients",
					value: false
				},
				{
					text: "Employees",
					value: true
				},
			];
		},
		disableTierFilter():boolean {
			return false;
			//return (this as any).v.accountStatus.isDemo;
		},
		disableDemoFilter():boolean {
			if(this.v.accountStatus.hasPermanentAccount){
				return true;
			}
			if(this.v.accountStatus.hasSubscription){
				return true;
			}
			return false;
		},
		disableDemoActiveFilter():boolean {
			return !(this as any).v.accountStatus.isDemo;
		},
		disablePermantentFilter():boolean {
			return (this as any).v.accountStatus.isDemo;
		},
		disableSubscriptionFilter():boolean {
			return (this as any).v.accountStatus.isDemo;
		},
		disablePermantentExtraFilter():boolean {
			return !(this as any).v.accountStatus.hasPermanentAccount;
		},
		disableSubscriptionExtraFilter():boolean {
			return !(this as any).v.accountStatus.hasSubscription;
		},
		accountCreatedByItems():ISelectItem<string | null>[]{
			return [
				{
					text: "Niet van toepassing",
					value: null
				},
				{
					text: "Is niet ingevuld",
					value: "none"
				},
				{
					text: "Winfakt Online",
					value: "winfakt online"
				},
				{
					text: "Winfakt Classic",
					value: "winfakt classic"
				},
				{
					text: "facturatie.be",
					value: "facturatie.be"
				}
			];
		},
		accountCreatedByValue():string | null{
			if (this.v.accountCreatedByNone) {
				return "none";
			}
			if (this.v.accountCreatedByWinfaktOnline) {
				return "winfakt online";
			}
			if (this.v.accountCreatedByWinfaktClassic) {
				return "winfakt classic";
			}
			if (this.v.accountCreatedByFacturatieBe) {
				return "facturatie.be";
			}
			return null;
		},
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.v = new CompanyFilters(this.value.getJSON());
			}
		},
		disableTierFilter() {
			if (this.disableTierFilter) {
				this.v.tiers = [];
			}
		},
		"v.accountStatus.hasPermanentAccount"() {
			if (!this.v.accountStatus.hasPermanentAccount) {
				this.v.accountStatus.activeService = false;
				this.v.accountStatus.expiredService = false;
				this.v.accountStatus.permanentService = false;
				this.v.accountStatus.hasBoughtSPAtLeastOnce = false;
				this.v.accountStatus.hasNeverBoughtSP = false;
			}
		},
		"v.accountStatus.hasSubscription"() {
			if (!this.v.accountStatus.hasSubscription) {
				this.v.accountStatus.isNotExpired = false;
				this.v.accountStatus.isExpired = false;
			}
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		confirm() {
			this.$emit("input", new CompanyFilters(this.v.getJSON()));
			this.close();
		},
		updateTier(tier: Tier, value: boolean) {
			let has = this.hasTier(tier);
			if (has == value) return;
			if (!value) {
				this.v.tiers.splice(this.v.tiers.indexOf(tier), 1);
			} else {
				this.v.tiers.push(tier);
			}
		},
		hasTier(tier: Tier): boolean {
			return this.v.tiers.indexOf(tier) != -1;
		},
		removeAccountCreatedByFilters(){
			this.v.accountCreatedByNone = false;
			this.v.accountCreatedByWinfaktOnline = false;
			this.v.accountCreatedByWinfaktClassic = false;
			this.v.accountCreatedByFacturatieBe = false;
		},
		setAccountCreatedByFilter(value:string | null){
			this.removeAccountCreatedByFilters();
			if (value == "none"){
				this.v.accountCreatedByNone = true;
			} else if (value == "winfakt online") {
				this.v.accountCreatedByWinfaktOnline = true;
			} else if (value == "winfakt classic") {
				this.v.accountCreatedByWinfaktClassic = true;
			} else if (value == "facturatie.be") {
				this.v.accountCreatedByFacturatieBe = true;
			}
		},
	},
	async mounted(){
		this.availableDbs = await MetricService.getAllDbIds();
	},
	components: {
		AppCompanyFiltersModules,
		AppCompanyEmploteyeeSelect,
		AppSelectDiscoveredUsFrom,
		AppSelectCompanyDidNotPurchaseReason,
		AppCompanyFiltersVars
	}
});
